module.exports = __webpack_public_path__ + "img/noto_kiss-mark_2.3172a312.png";